import { useParams } from 'react-router-dom';
type InterventionUrl = {
  interventionKey: string;
};

const useInterventionKey = () => {
  const params = useParams<InterventionUrl>();
  return !params.interventionKey || params.interventionKey.startsWith('x')
    ? params.interventionKey
    : Number(params.interventionKey);
};

export { useInterventionKey };
